import axios from "axios";
import { message } from 'ant-design-vue';
import { getLanguage } from './translate';

const service = axios.create({
    // baseURL 需要设置为反向代理前缀，不能设置绝对路径URL
    baseURL: './',
    timeout: 30000,
    withCredentials: false,
    headers: {
        'X-Custom-Header': 'freqx',
        'Content-Type': "application/json"
    }
})

if (localStorage.getItem('token')) {
    service.defaults.headers.common['Authorization'] = "Bearer " + localStorage.getItem('token');
}

// 添加请求拦截器
service.interceptors.request.use(function (req) {

    if (localStorage.getItem('token')) {
        req.headers.Authorization = "Bearer " + localStorage.getItem('token');
    }

    // 当前查看工厂
    if (localStorage.getItem('currentFactory')) {
        req.headers.currentFactory = localStorage.getItem('currentFactory');
    } else {
        req.headers.currentFactory = null;
    }

    //req.headers = Object.apply(service.defaults.headers, req.headers);
 
    if (req.headers.requestId) {
        service.defaults.headers.common['requestId'] = req.headers.requestId;
    }
    return req;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

//添加响应拦截器
service.interceptors.response.use((response: any) => {
    // 对响应数据做点什么
    const res = response.data;
    if (res.status == 200 || res.code === 200) {
        return res;
    } else if (res.status == 401) {
        if (res.message) {
            message.warn(getLanguage(res.message));
        }
        // 跳转登录页面

    } else {
        let em = res.message
        if(em.includes('该账号已锁定，请')) {
            let l1 = em.split('该账号已锁定，请')
            let l2 = l1[1].split('分钟后再试!')
            em = getLanguage('该账号已锁定，请') + l2[0] + getLanguage('分钟后再试!')
        } else {
            em = getLanguage(em)
        }
        message.warn(em);
        // return Promise.reject(new Error(res.message || "Error"));
    }
},
    function (error) {
        if (error && error.response) {
            switch (error.response.status) {
                case 400:
                    error.message = "bad request(400)"
                    break
                case 401:
                    error.message = "unauthorized(401)"
                    break
                case 403:
                    error.message = "access denied(403)"
                    break
                case 404:
                    error.message = `wrong address: ${error.response.config.url}`
                    break
                case 405:
                    error.message = "unsupported method(405)"
                    break
                case 408:
                    error.message = "timeout(408)"
                    break
                case 500:
                    error.message = "server internal error(500)"
                    break
                case 501:
                    error.message = "not implemented(501)"
                    break
                case 502:
                    error.message = "bad gateway(502)"
                    break
                case 503:
                    error.message = "service unavailable(503)"
                    break
                case 504:
                    error.message = "gateway timeout(504)"
                    break
                case 505:
                    error.message = "HTTP version not supported(505)"
                    break
                default:
                    error.message = `connection error: ${error.message}`
            }
        } else {
            if (error.message == "Network Error") error.message == "network error, please try again later";
            error.message = "connection to server failed, please contact administrator";
        }
        message.warn(error.message);
        // return Promise.reject(error);
    });

export default service
